import useRootStore from '@/store/root';
import $t from '@Ravnur-Inc/l10n/$t';
import { Vue } from 'vue-class-component';

import './matomo-dashboard.scss';

const CN = 'matomo-dashboard';

export default class MatomoDashboard extends Vue {
  get matomoToken() {
    return useRootStore().configurations?.analytics.matomoToken;
  }

  get matomoSite() {
    return useRootStore().configurations?.analytics.matomoSiteId;
  }

  get matomoHost() {
    return useRootStore().configurations?.analytics.matomoHost;
  }

  get matomoEnabled() {
    return useRootStore().configurations?.analytics.matomoAnalyticsEnabled;
  }

  render() {
    return (
      <div class={CN}>
        {this.matomoEnabled && this.matomoToken && (
          <>
            <div class={`${CN}__widgets-wrapper`}>
              <div class={`${CN}__widgets-wrapper--col`}>
                <card
                  class={`${CN}__widgets-item`}
                  title={$t('common', 'dashboard__real-time-plays')}
                >
                  <div id="widgetIframe">
                    <iframe
                      frameborder="0"
                      height="140"
                      marginheight="0"
                      marginwidth="0"
                      scrolling="yes"
                      src={`${this.matomoHost}/index.php?module=Widgetize&action=iframe&disableLink=1&widget=1&moduleToWidgetize=MediaAnalytics&actionToWidgetize=currentPlays&idSite=${this.matomoSite}&period=day&date=yesterday&token_auth=${this.matomoToken}`}
                      width="100%"
                    ></iframe>
                  </div>
                </card>
                <card
                  class={`${CN}__widgets-item`}
                  title={$t('common', 'dashboard__most-popular-24-hours')}
                >
                  <iframe
                    frameborder="0"
                    height="350"
                    marginheight="0"
                    marginwidth="0"
                    scrolling="yes"
                    src={`${this.matomoHost}/index.php?module=Widgetize&action=iframe&lastMinutes=1440&disableLink=1&widget=1&moduleToWidgetize=MediaAnalytics&actionToWidgetize=mostPlays&idSite=${this.matomoSite}&period=day&date=yesterday&token_auth=${this.matomoToken}`}
                    width="100%"
                  ></iframe>
                </card>
              </div>
              <div class={`${CN}__widgets-wrapper--col`}>
                <card
                  class={`${CN}__widgets-item`}
                  title={$t('common', 'dashboard__time-spend-playing')}
                >
                  <div id="widgetIframe">
                    <iframe
                      frameborder="0"
                      height="140"
                      marginheight="0"
                      marginwidth="0"
                      scrolling="yes"
                      src={`${this.matomoHost}/index.php?module=Widgetize&action=iframe&disableLink=1&widget=1&moduleToWidgetize=MediaAnalytics&actionToWidgetize=currentTime&idSite=${this.matomoSite}&period=day&date=yesterday&token_auth=${this.matomoToken}`}
                      width="100%"
                    ></iframe>
                  </div>
                </card>
                <card
                  class={`${CN}__widgets-item`}
                  title={$t('common', 'dashboard__most-popular-30-mins')}
                >
                  <iframe
                    frameborder="0"
                    height="350"
                    marginheight="0"
                    marginwidth="0"
                    scrolling="yes"
                    src={`${this.matomoHost}/index.php?module=Widgetize&action=iframe&lastMinutes=30&disableLink=1&widget=1&moduleToWidgetize=MediaAnalytics&actionToWidgetize=mostPlays&idSite=${this.matomoSite}&period=day&date=yesterday&token_auth=${this.matomoToken}`}
                    width="100%"
                  ></iframe>
                </card>
              </div>
            </div>
            <card class={`${CN}__widgets-item`} title={$t('common', 'dashboard__report')}>
              <iframe
                frameborder="0"
                height="460"
                marginheight="0"
                marginwidth="0"
                scrolling="yes"
                src={`${this.matomoHost}/index.php?forceView=1&viewDataTable=sparklines&module=Widgetize&action=iframe&disableLink=1&widget=1&moduleToWidgetize=MediaAnalytics&actionToWidgetize=get&idSite=${this.matomoSite}&period=day&date=yesterday&token_auth=${this.matomoToken}`}
                width="100%"
              ></iframe>
            </card>
          </>
        )}
      </div>
    );
  }
}
